import fetchClient from "api/client";
import SCHEDULED_REPORTS_ENDPOINT from "./scheduledReportsEndpoint";

/**
 * @description POST /api/reports-schedule/preview-sql
 * @param {object} payload - The payload object.
 * @param {object} payload.body - The sql.
 * @returns {Promise}
 */
export default function previewSql({ sql }) {
  const url = `${SCHEDULED_REPORTS_ENDPOINT}/preview-sql`;

  return fetchClient.post(url, { body: { sql } });
}
